import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { getInvoiceByName } from "api/invoice.api";

export const useGetInvoiceByName = (name) => {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ["extracted-invoice"],
    queryFn: () => getInvoiceByName(name),
    initialData: () => queryClient.getQueryData(["extracted-invoice"]),
    select: (data) => data.invoice,
    enabled: !!name, // Only fetch when name is provided
    staleTime: 1000 * 60 * 50, // 50 minutes
    onError: (error) => {
      console.error("Error fetching invoice by name:", error);
    },
  });
};
